import { createSlice } from '@reduxjs/toolkit';
import {
  addSheetMetal,
  deleteSheetMetal,
  fetchSheetMetalList,
  printMetalSheet,
} from './metalSheetThunk';

const initialState = {
  metalSheets: [],
  pagination: [],
  loading: false,
  error: null,
  successMessage: null,
};

const metalSheetSlice = createSlice({
  name: 'metalSheet',
  initialState,
  reducers: {
    clearMetalSheetState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSheetMetal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSheetMetal.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Sheet metal saved successfully';
      })
      .addCase(addSheetMetal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to save sheet metal';
      })
      .addCase(fetchSheetMetalList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSheetMetalList.fulfilled, (state, action) => {
        state.loading = false;
        state.metalSheets = action.payload.data;
        state.pagination = {
          total: action.payload.total,
          per_page: action.payload.per_page,
          current_page: action.payload.current_page,
          last_page: action.payload.last_page,
        };
      })
      .addCase(fetchSheetMetalList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch sheet metal list';
      })
      .addCase(deleteSheetMetal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSheetMetal.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Sheet metal deleted successfully';
      })
      .addCase(deleteSheetMetal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete sheet metal';
      })
      .addCase(printMetalSheet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(printMetalSheet.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printMetalSheet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to print metal sheet';
      });
  },
});

export const { clearMetalSheetState } = metalSheetSlice.actions;
export default metalSheetSlice.reducer;
